import { getClusterEndpoint } from '../clusters/action-helpers'
import { getActiveRegion } from 'api-client/helpers'

interface CreateKaapiBYOClusterBodyParams {
  name: string
  namespace: string
  controlplaneName: string
}

export const createKaapiBYOClusterBody = ({
  name,
  namespace,
  controlplaneName,
}: CreateKaapiBYOClusterBodyParams) => {
  return {
    apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
    kind: 'ByoCluster',
    metadata: {
      name,
      namespace,
      labels: {
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
      },
    },
    spec: {
      bundleLookupBaseRegistry: 'quay.io/platform9',
      controlPlaneEndpoint: {
        host: getClusterEndpoint({ clusterName: controlplaneName }),
        port: 443,
      },
    },
  }
}
